// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kH-z","hovered":"lH-z","hoverImage":"mH-z","mainImage":"nH-z","imageNoBackground":"oH-z","fullSizeImage":"pH-z"};